// @ts-expect-error file not yet converted
import * as LoginUtils from '../lib/LoginUtils';
import BaseLoginDao from './BaseLoginDao';
import { OUTLOOK365 } from '../constants/LoginSources';
import http from 'hub-http/clients/noAuthApiClient';

class SsoLoginDao extends BaseLoginDao {
  startLogin(credentials) {
    const source = LoginUtils.getLoginSource();

    if (source === OUTLOOK365) {
      credentials.rememberLogin = true;
    }

    return this.loginAtPath('/login-api/v1/saml/login', credentials);
  }

  loginViaToken(credentials) {
    const source = LoginUtils.getLoginSource();

    if (source === OUTLOOK365) {
      credentials.rememberLogin = true;
    }

    return this.loginAtPath('/login-api/v1/saml/acs-token', credentials);
  }

  completeAcsLogin(credentials) {
    return http.post(`/login-api/v1/saml/acs-complete`, {
      data: credentials
    });
  }

}

export default SsoLoginDao;